// Copyright © 2021 Move Closer
import { SizeMap } from '../../_composables';
import { BootstrapTheme } from '../common';
/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export const bootstrapLinkSizeRegistry = {
    [SizeMap.Large]: 'fs-4',
    [SizeMap.Medium]: '',
    [SizeMap.Small]: 'fs-6',
    [SizeMap.XLarge]: 'fs-3',
    [SizeMap.XSmall]: 'small'
};
/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export const bootstrapLinkColorRegistry = {
    [BootstrapTheme.Default]: 'text-primary',
    [BootstrapTheme.Danger]: 'text-danger',
    [BootstrapTheme.Dark]: 'text-dark',
    [BootstrapTheme.Info]: 'text-info',
    [BootstrapTheme.Light]: 'text-light',
    [BootstrapTheme.Primary]: 'text-primary',
    [BootstrapTheme.Success]: 'text-success',
    [BootstrapTheme.Warning]: 'text-warning'
};
/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export const bootstrapLinkDecorationRegistry = {
    true: 'text-decoration-underline',
    false: 'text-decoration-none'
};
/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export const bootstrapLinkWeightRegistry = {
    true: 'fw-bold',
    false: ''
};
